import React from 'react';
import Navbar from '../composant/Navbar';
import HeroSection from '../composant/HeroSection';
import NetworkDisplay from '../composant/NetworkDisplay';
import MapCD from '../composant/MapCD';
import PartenaireSection from '../composant/PartenaireSection';
import PackagesDisplay from '../composant/PackageDisplay';
import ContactDisplay from '../composant/ConstactDisplay';
import FooterButton from '../composant/FooterButton';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <HeroSection />
      <NetworkDisplay />
      <PackagesDisplay />
      <MapCD />
      <PartenaireSection />
      <ContactDisplay />
      <FooterButton />
      {/* Autres sections seront ajoutées ici */}
    </div>
  );
};

export default HomePage;